import React from 'react';
const AppContainer = (props) => {
    return (
        <div className='flex flex-col justify-center w-11/12 md:w-10/12'>
            {props.children}
        </div>
    )
}

export default AppContainer;